import { lazy } from 'react';

const ButtonLogViewConfig = {
  settings: {
    layout: {
      config: {},
    },
  },
  routes: [
    {
      path: '/button-log',
      component: lazy(() => import('./ButtonLogViewApp')),
    },
  ],
};

export default ButtonLogViewConfig;
